// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.46969 5.46967C8.76259 5.17678 9.23746 5.17678 9.53035 5.46967L14.3033 10.2426C14.5962 10.5355 14.5962 11.0104 14.3033 11.3033C14.0104 11.5962 13.5356 11.5962 13.2427 11.3033L9.75002 7.81066V16.25H19V17.75H8.25002V7.81066L4.75738 11.3033C4.46449 11.5962 3.98961 11.5962 3.69672 11.3033C3.40383 11.0104 3.40383 10.5355 3.69672 10.2426L8.46969 5.46967Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
